import { JSXElement, mergeProps, splitProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';
import { ark, HTMLArkProps } from '@ark-ui/solid';

type TdProps = HTMLArkProps<'td'>;

export default function Td(props: TdProps): JSXElement {
  const merged = mergeProps(
    {
      class: ''
    },
    props
  );
  const [split, rest] = splitProps(merged, ['class', 'children']);
  return (
    <ark.td
      class={twMerge(`px-3 py-3 first:px-6 first:py-3`, split.class)}
      {...rest}
    >
      {split.children}
    </ark.td>
  );
}
